import ProfileCreationPage from './ProfileCreationPage';

export default ProfileCreationPage;